import React, { useState } from "react";
import { graphql, Link } from "gatsby"
import { useLocation } from "@reach/router"
import ContentModule from "../modules/content_module";
import LocRatingMap from "../components/map/loc-rating-map-details"
import Layout from "../components/Layout"
import { Container, Row, Col } from "react-bootstrap"
import AreaGuideBanner from "../components/AreaGuideBanner/AreaGuideBanner";
import Journey from "../components/Journey/Journey";
import Reviews from "../components/Reviews/Reviews";
import { PageLinks } from "../common/page-links";
import "../scss/branch-details.scss";
import FeaturesAreaGuide from "../components/Features/FeaturesAreaGuide";
import Customer from "../components/Customer/Customer";
import FAQ from "../components/Faq/Faq"
import VideoGallery from "../components/VideoGallery/VideoGallery";
import _ from "lodash";

// markup
const AreaGuideDetails = ({ data }) => {
    const location = useLocation();

    const [show, setClass] = useState(false);
    const handleShow = () => {
        setClass(!show);
    }

    const { glstrapi: { areaGuide, globalModule, sale_properties, let_properties, student_properties } } = data; 
    var GQLModules = areaGuide?.add_components;

    let tab_list = []

    if(sale_properties.length > 0){
        tab_list.push(
            {
                "tab_name": "Property for Sale",
                "add_tab": "residential_sales",
                "property_list": sale_properties
            }
        )
    }
    if(let_properties.length > 0){
        tab_list.push(
            {
                "tab_name": "Property to Rent",
                "add_tab": "residential_lettings",
                "property_list": let_properties
            }
        )
    }


    if(process.env.GATSBY_SITE_NAME === "Stonehouse"){
        tab_list = [
            {
                "tab_name": "Property to Rent",
                "add_tab": "residential_lettings",
                "property_list": let_properties
            }
        ]
    }

    if(areaGuide?.title.toLowerCase().indexOf("students") >= 0){
        tab_list = [
            {
                "tab_name": "Property to Rent",
                "add_tab": "residential_lettings",
                "property_list": student_properties
            }
        ]
    }

    //console.log("students ==>", areaGuide?.title.toLowerCase().indexOf("students"))

    // Get Map Details
    let mapItems = [];
    let mapItem = {};
    mapItem['lat'] = areaGuide.latitude
    mapItem['lng'] = areaGuide.longitude
    mapItem['id'] = areaGuide.id

    const mapMarkerImageShowFlag = 0;
    mapItems.push(mapItem);
    // Get Map Details

    let meta_data = areaGuide?.title ? { title: `${areaGuide?.title} Area Guide`, description: `Know more about ${areaGuide?.title} here. Contact one of our estate agents for assistance in finding the right property for you in ${areaGuide?.title}.` } : "";

    let googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${areaGuide?.office?.latitude},${areaGuide?.office?.longitude}`;

    //console.log("featured ==>", sale_properties, let_properties)

    return (
        <div className="area_guide_details">
            {areaGuide?.title &&
                <Layout seo_meta={meta_data} isJourneySec={true} menu_slug={"area-guide-details"} GQLPage={{layout:"static_template"}}>
                    <>
                        <AreaGuideBanner area_guide_data={areaGuide} location={location} />

                        <section className="static-details">
                            <Container>
                                <Row>
                                    <Col>
                                        <div className="details-wrap">
                                            <div className="details-left">
                                                <h3>Welcome to {areaGuide?.title}</h3>

                                                <div className={show ? "summary show" : "summary show"} >
                                                    <ContentModule Content={areaGuide?.content} />
                                                </div>
                                                {/* <button className={show ? "more show" : "more"} onClick={handleShow} >Read {show ? "Less" : "More"} <i className="icon-dropdown"></i> </button> */}
                                            </div>
                                            {areaGuide?.office && 
                                                <div className="details-right">
                                                    <h3>Nearest Branch</h3>
                                                    <p>
                                                        <b>{areaGuide?.office?.name}</b><br />
                                                        {areaGuide?.office?.mobile && <a href={`tel:${areaGuide?.office?.mobile}`}>{areaGuide?.office?.mobile}</a>}<br />
                                                        {areaGuide?.office?.email && <Link to={`/${PageLinks.branch_finder}/${areaGuide?.office.slug}/${PageLinks.branch_contact}/`} className="mail">{areaGuide?.office?.email.toLowerCase()}</Link>}
                                                    </p>
                                                    <p>
                                                        {areaGuide?.office?.address}<br />
                                                        {areaGuide?.office?.latitude && areaGuide?.office?.longitude &&
                                                            <a href={googleMapsUrl} target="_blank" className="mail">Get Google Directions</a>
                                                        }
                                                    </p>

                                                    <Link to={`/${PageLinks.request_valuation}/`} className="btn btn-primary">Book a valuation</Link>
                                                </div>
                                            }
                                           
                                        </div>
                                    
                                    </Col>
                                </Row>
                            </Container>
                        </section>

                        <VideoGallery property_data={areaGuide} layout_type={"areaguide_layout"}  />

                        {GQLModules?.length > 0 && GQLModules?.map((Module, index) => {
                            return(
                                <>
                                    {Module.__typename === "GLSTRAPI_ComponentComponentsVideoSection" &&  <Customer key={Module} Module={Module} GQLPage={areaGuide} areaguide_template={true} />}

                                    {Module.__typename ==="GLSTRAPI_ComponentComponentsFaq" && 
                                    <section className={`faq_section ${Module?.faq_bg}`} id="faqs">
                                        <Container>
                                            <Row>
                                                <Col><FAQ key={Module} Module={Module} /></Col>
                                            </Row>
                                        </Container>
                                    </section>
                                    }
                                </>
                            )
                        })}
                      
                        {(areaGuide.latitude && areaGuide.longitude) ?
                            <section className="map">
                                <div className="map-img">
                                    <Container>
                                        <LocRatingMap data={mapItems} />
                                    </Container>
                                </div>
                            </section>
                            :
                            <></>
                        }

                        {(sale_properties.length > 0 || let_properties.length > 0) && (
                            <FeaturesAreaGuide area_name={_.trim(areaGuide?.title)} tab_list={tab_list} />
                        )}


                        <Journey />
                    </>
                </Layout>
            }
        </div>
    )
}

export default AreaGuideDetails

export const query = graphql`
query areaGuideDetailQuery($id: ID!, $area_name: String!, $office_crm_id: String!) {
    glstrapi { 
        globalModule {
            branch_statistics {
                id
                icon_class
                heading
                content
            }
        }

        sale_properties:properties(sort:"price:desc",where:{_or: [{display_address_contains: $area_name}, {office_crm_id_eq: $office_crm_id}], publish:true, department:"residential", search_type:"sales", status_in:["For Sale", "Sale Agreed"]}, limit:12){
            id
            crm_id
            display_address
            title
            slug
            department
            status
            search_type
            price
            price_qualifier
            bedroom
            bathroom
            parking
            reception
            images
            imagetransforms
            available_from
            extra
            property_type
            office_crm_id
            ggfx_results {
                id
                content_type
                transforms
                src_import_url
                src_cftle
                field
            }
        }

        let_properties:properties(sort:"price:desc",where:{publish:true, department:"residential", search_type:"lettings", display_address_contains: $area_name, status_in:["To Let", "Let Agreed"]}, limit:12){
            id
            crm_id
            display_address
            title
            slug
            department
            status
            search_type
            price
            price_qualifier
            bedroom
            bathroom
            parking
            reception
            images
            imagetransforms
            available_from
            extra
            property_type
            office_crm_id
            ggfx_results {
                id
                content_type
                transforms
                src_import_url
                src_cftle
                field
            }
        }

        student_properties:properties(sort:"price:desc",where:{publish:true, department:"residential", search_type:"lettings", status_in:["To Let", "Let Agreed"]}, limit:12){
            id
            crm_id
            display_address
            title
            slug
            department
            status
            search_type
            price
            price_qualifier
            bedroom
            bathroom
            parking
            reception
            images
            imagetransforms
            available_from
            extra
            property_type
            office_crm_id
            ggfx_results {
                id
                content_type
                transforms
                src_import_url
                src_cftle
                field
            }
        }

        areaGuide(id: $id) {
            id
            
            banner_image {
                url
                alternativeText
              }
            content
            imagetransforms
            ggfx_results {
                id
                content_type
                transforms
                src_import_url
                src_cftle
                field
            }
            latitude
            longitude
            publish
            slug
            title
            banner_content
            gallery_title
            images:gallery_image {
                url
                alternativeText
            }
            office {
                name
                mobile
                email
                address
                latitude
                longitude
            }
            add_components {
                __typename
                ... on GLSTRAPI_ComponentComponentsVideoSection {
                    id
                    title
                    content
                    read_more_content
                    embed_video_url
                    bg_color
                    cust_padd:padding
                    vid_layout_type:layout_type
                    vid_img_align:image_align
                    button_CTA:Button_CTA {
                        target
                        theme
                        
                        label
                        custom_link
                        menu_item {
                            slug
                            parent {
                            slug
                                parent {
                                    slug
                                    parent {
                                        slug
                                    }
                                }
                            }
                        }
                    }
                    image {
                        url
                        alternativeText
                    }
                }

                ... on GLSTRAPI_ComponentComponentsFaq {
                    id
                    title
                    title_content
                    theme
                    faq_bg:bg_color
                    faq_padd:padding
                    faq {
                    answer
                    question
                    }
                }
            }
        } 
    }
}`